import { defineMessages } from 'react-intl';

export default defineMessages({
  companyAdminDevicesDataGridRowMenuEdit: {
    defaultMessage: 'Edit device',
    description: 'Table row actions - edit',
    id: 'companyAdminDevicesDataGrid.dataGridRowMenuEdit',
  },
});
